import { Share } from 'types';

export const getSharesCountTotal = (shares: Share[]) =>
  shares.reduce((acc, share) => {
    const shareCount = share.to - share.from + 1;
    return acc + shareCount;
  }, 0);
